// imports
import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// components
import BottleSizeSelect from 'components/common/simpleSelectors/BottleSize';
//interfaces , constants , helper
import { BottleSizeSelectorProps } from 'interfaces';

const BottleSizeSelector: FC<BottleSizeSelectorProps> = ({ name, title, handleChange, ...rest }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const { name, onBlur, onChange, value } = field;
        const { error } = fieldState;
        const { message } = error || {};

        return (
          <BottleSizeSelect
            name={name}
            title={title}
            value={value}
            onBlur={onBlur}
            handleChange={(val) => {
              onChange(val);
              handleChange && handleChange(val);
            }}
            error={Boolean(message)}
            helperText={message}
            {...rest}
          />
        );
      }}
    />
  );
};

export default BottleSizeSelector;
